import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from './views/Dashboard.vue';
import Recent from './views/Recent.vue';

import SignIn from './views/SignIn.vue';
import SignUp from './views/SignUp.vue';

import Feeds from './views/Feeds.vue';
import Chatbots from './views/Chatbots.vue';
import Crawlers from './views/Crawlers.vue';
import Emails from './views/Emails.vue';
import Trash from './views/Trash.vue';
import Archive from './views/Archive.vue';

import { store } from './store/store'

Vue.use(VueRouter);


const routes = [
  { path: '/', name: 'dashboard', component: Dashboard, meta: {requiresAuth: true} },
  { path: '/signin', name: 'signin', component: SignIn },
  { path: '/signup', name: 'signup', component: SignUp },
  { path: '/feeds', name: 'feeds', component: Feeds, meta: {requiresAuth: true} },
  { path: '/recent', name: 'recent', component: Recent, meta: {requiresAuth: true}  },
  { path: '/chatbots', name: 'chatbots', component: Chatbots, meta: {requiresAuth: true} },
  { path: '/crawlers', name: 'crawlers', component: Crawlers, meta: {requiresAuth: true} },
  { path: '/emails', name: 'emails', component: Emails, meta: {requiresAuth: true} },
  { path: '/trash', name: 'trash', component: Trash, meta: {requiresAuth: true} },
  { path: '/archive', name: 'archive', component: Archive, meta: {requiresAuth: true} },
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: routes
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      console.log('> User logged in.');
      next();
      return
    }
    console.log('user is NOT logged in; redirecting');
    next({
      path: '/signin',
      // query: { redirect: to.fullPath }
    });
  } else {
    next();
  }
})

export default router
